export const ENDPOINTS = {
	SEARCH_ACTIVE_WORKER: '/flex/global-overview/find-workers'
};

export default { ENDPOINTS };
